import Vue from 'vue'
import LogService from './api/broadcast/LogService'
import App from './App.vue'
import router from './router'
import store from './store/vuex'
import i18n from './i18n'
import '@/assets/style/main.scss'
import '@/shared/toast'

Vue.config.productionTip = false

Vue.config.errorHandler = (error) => LogService.UncaughtError(`Join Uncaught Error ${error}`)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
